import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as Services from '../services';
import Form from '../components/InputField';
import Tree from '../components/Tree';

import graphic from '../assets/images/graphic.png';

const mapStateToProps = ({ allPage }) => {
  const data = _.map(allPage, (value, key) => {
    // console.log('contact', _.find(value, page => _.get(page, 'slug') === 'contact'));
    return {
      key,
      ..._.find(value, page => _.get(page, 'slug') === 'contact')
    };
  });
  // console.log('contact keyBy', _.keyBy(data, 'key'));
  return {
    faqData: _.keyBy(data, 'key')
  };
};

const actions = {};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successText: null,
      errorText: null,
    };
    this.stausClearSuccess = null;
    this.stausClearError = null;
  }

  componentDidUpdate() {
    const { successText } = this.state;
    clearInterval(this.stausClearSuccess);
    if (successText) {
      this.stausClearSuccess = setTimeout(() => {
        if (successText) this.setState({ successText: null });
      }, 5000);
    }
  }
  handleSubmit = async (values) => {
    try {
      const content = await Services.sendEnquiry(values);
      if (content.status === 'mail_sent') {
        this.setState({
          successText: 'Your email has been successfully sent.',
          errorText: null,
        });
      } else {
        this.setState({
          successText: null,
          errorText: 'Oops, something went wrong please try again',
        });
      }
      return content;
    } catch (err) {
      this.setState({
        successText: null,
        errorText: 'Oops, something went wrong please try again',
      });
      return err;
    }
  };
  render() {
    const { getContentLanguage } = this.props;
    const fields = [
      {
        fieldKey: 'your-name',
        name: getContentLanguage('name'),
        type: 'input'
      },
      {
        fieldKey: 'your-company',
        name: getContentLanguage('company'),
        type: 'input'
      },
      {
        fieldKey: 'your-tel',
        name: getContentLanguage('tel'),
        type: 'input'
      },
      {
        fieldKey: 'your-email',
        name: getContentLanguage('email'),
        type: 'input'
      },
      {
        fieldKey: 'your-message',
        name: getContentLanguage('message'),
        type: 'textArea'
      }
    ];
    const { faqData, language } = this.props;
    const { successText, errorText } = this.state;
    const data = _.get(faqData, `${language}.acf.faq`, []);
    return (
      <div className="contact-screen">
        <div className="row no-gutters">
          <div className="col-12 col-md-6 left">
            <div className="wrap-faq col-12 col-md-10 col-lg-8">
              <h2 className="head darkGray">{getContentLanguage('faq')}</h2>
              <Tree dataSource={data} initial={0} name="faq-tree" language={language} />
            </div>
            <div className="graphic">
              <img src={graphic} alt="" />
            </div>
          </div>
          <div className="col-12 col-md-6 right">
            <div className="wrap-form col-12">
              <h2 className="head darkGray">{getContentLanguage('request')}</h2>
              <Form getContentLanguage={getContentLanguage} fields={fields} onSubmit={v => this.handleSubmit(v)} />
              { successText && <div className="alert-success">{successText}</div>}
              { errorText && <div className="alert-failed">{errorText}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);




// WEBPACK FOOTER //
// ./src/screens/Contact.js